// @flow
import React from "react";
import styled, { css } from "styled-components";
import { ButtonLink } from "@nested/component-library";
import { regularHeading, mediumHeading } from "@nested/rebrand";
import { media } from "../../media";

const background = css`
  background-color: ${({ backgroundColor, theme }) =>
    theme.palette[backgroundColor.toLowerCase()]};
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 1140px;
  width: 100%;
  ${media.desktop`
    flex-direction: row;
    justify-content: space-between;
    padding: 50px 30px;
  `}
`;

const logo = css`
  height: 120px;
  margin: 30px 0 15px 0;
  width: 120px;
  ${media.desktop`
    margin: 0;
  `}
`;

const textSection = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 40px 0 40px;
  ${media.desktop`
    display: inline-block;
    padding: 0 0 0 10px;
    width: 65%;
  `}
`;

const Header = styled.div`
  ${regularHeading}
  font-size: 24px;
  margin: 0 15px 10px 15px;
  text-align: center;
  ${media.tablet`
    ${mediumHeading}
    font-size: 36px;
  `}
  ${media.desktop`
    margin: 0 0 10px 0;
    text-align: left;
  `}
`;

const Content = styled.div`
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  font-weight: 500;
  ${media.desktop`
    text-align: left;
  `}
`;

const buttonSection = css`
  margin: 20px 0 30px 0;
`;

const buttonStyles = css`
  font-size: 18px;
  width: 120px;
  padding: 8px 30px;
`;

type Props = {
  backgroundColor: string,
  bannerImage: PrismicImage,
  header: string,
  content: string,
  ctaText: string,
  ctaLink: PrismicLink,
};

export const BannerWithImage = ({
  backgroundColor = "pink",
  bannerImage,
  header,
  content,
  ctaText,
  ctaLink,
}: Props) => (
  <div backgroundColor={backgroundColor} css={background}>
    <Wrapper>
      <div>
        <img alt="Banner Logo" css={logo} src={bannerImage?.url} />
      </div>
      <div css={textSection}>
        <Header>{header}</Header>
        <Content>{content}</Content>
      </div>
      <div css={buttonSection}>
        <ButtonLink
          css={buttonStyles}
          type="primary"
          to={ctaLink.url}
          target={ctaLink?.target}
        >
          {ctaText}
        </ButtonLink>
      </div>
    </Wrapper>
  </div>
);
